export const STEPS = ['Customer', 'Shipping', 'Billing', 'Payment']
